module.exports = __webpack_public_path__ + "img/vector_left.52765c51.svg";